import { Auth as SupabaseAuth } from '@supabase/auth-ui-react';
import { supabase } from '../lib/supabase';

export function Auth() {
  if (!supabase) {
    return (
      <div className="w-full max-w-md p-4 bg-amber-50 rounded-lg text-center">
        <p className="text-amber-700 mb-2">Supabase connection required</p>
        <p className="text-sm text-amber-600">
          Please click the "Connect to Supabase" button to enable authentication
        </p>
      </div>
    );
  }

  return (
    <div className="w-full max-w-md mx-auto">
      <button
        onClick={() => supabase.auth.signInWithOAuth({
          provider: 'google',
          options: {
            redirectTo: window.location.origin,
          }
        })}
        className="w-full flex items-center justify-center gap-3 bg-white px-6 py-3 border border-gray-300 rounded-lg shadow-sm text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors duration-200"
      >
        <img
          src="https://www.google.com/favicon.ico"
          alt="Google"
          className="w-6 h-6"
        />
        Sign in with Google
      </button>
    </div>
  );
}